import { render } from "./Home.vue?vue&type=template&id=00daa9e8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "@/styles/pages/home.scss?vue&type=style&index=0&id=00daa9e8&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00daa9e8"]])

export default __exports__